<template>
  <div class="info-block-label-container">
    <div v-show="isShowLeft" ref="label1" class="label"> <!--左label-->
      <div class="vertical-middle">
        {{ leftLabel }}
        <span v-if="leftRedInspector" class="red-inspector">*</span>
      </div>
    </div>
    <div v-show="isShowLeft" class="value">
      <div class="vertical-middle">
        <template v-if="isShowLeft"> <!--不显示左边时，去除slot里面的内容，防止表单验证拦截-->
          <slot name="leftValue">
            {{ innerValue(leftValue) }}
          </slot>
        </template>
      </div>
    </div>

    <template v-if="!singleLabel">
      <div v-show="isShowRight" ref="label2" class="label"> <!--右label-->
        <div class="vertical-middle">
          {{ rightLabel }}
          <span v-if="rightRedInspector" class="red-inspector">*</span>
        </div>
      </div>
      <div v-show="isShowRight" class="value">
        <div class="vertical-middle">
          <template v-if="isShowRight">
            <slot name="rightValue">
              {{ innerValue(rightValue) }}
            </slot>
          </template>
        </div>
      </div>
    </template>
  </div>

</template>

<script setup>
const isShowLeft = ref(true), isShowRight = ref(true), leftRedInspector = ref(false), rightRedInspector = ref(false)

const props = defineProps({
  leftLabel: {
    type: String,
    required: true
  },
  leftValue: {
    type: [String, Number, Date],
    default: ''
  },
  rightLabel: {
    type: String,
    default: ''
  },
  rightValue: {
    type: [String, Number, Date],
    default: ''
  },
  singleLabel: { // 单标签，必须设置
    type: Boolean,
    default: false
  },
})

function innerValue(val) {
  if (val === 0) {
    return '0'
  }
  if (!val) {
    return ''
  }
  if (typeof (val) === 'number') {
    return val
  } else if (typeof (val) === 'string') {
    return val
  } else if (typeof (val) === 'object') { // 对象
    if (val instanceof Date) { // 日期处理
      return moment(val).format(this.dateFormatter)
    } else {
      return val
    }
  }
}

</script>


<style scoped lang="scss">
$df-info-label-bg: #fafafa; //label的背景色
$df-info-label-font-size: 15px; //label的字体大小
$df-info-label-font-color: #909399; //label的字体颜色
$df-info-label-font-weight: 700;
$df-info-label-letter-spacing: 0.75px; //label的间距
$df-info-label-top-bottom-padding: 7px; //label上下内间距
$df-info-label-left-right-padding: 13px;
$df-info-label-width: 115px; // label的宽
$df-info-label-line-height: 24px; //label的行高

$df-info-value-width: 330px; //value的宽
$df-info-value-font-size: 14px; //value的字体大小
$df-info-value-font-weight: 400;
$df-info-value-font-color: rgb(96, 98, 102);
$df-info-value-padding: 7px 13px;
$df-info-value-letter-spacing: 0px; //value文字间距
$df-info-value-line-height: 24px; //value的行高
$df-info-border: 1px solid #ebeef5; //内容展示器边框

.info-block-label-container {
  display: flex;
  border-right: $df-info-border;

  &:first-of-type {
    border-top: $df-info-border;
  }

  .label {
    border-bottom: $df-info-border;
    border-left: $df-info-border;
    border-right: $df-info-border;

    width: $df-info-label-width; // 固定宽度
    flex-shrink: 0; // 固定宽度
    background: $df-info-label-bg;
    font-size: $df-info-label-font-size;
    letter-spacing: $df-info-label-letter-spacing;
    font-weight: $df-info-label-font-weight;
    padding-top: $df-info-label-top-bottom-padding;
    padding-bottom: $df-info-label-top-bottom-padding;
    padding-left: $df-info-label-left-right-padding;
    padding-right: $df-info-label-left-right-padding;
    color: $df-info-label-font-color;
    line-height: $df-info-label-line-height;
  }

  .value {
    border-bottom: $df-info-border;
    width: 0;
    flex-grow: 1;

    word-break: break-all;
    font-size: $df-info-value-font-size;
    font-weight: $df-info-value-font-weight;
    padding: $df-info-value-padding;
    letter-spacing: $df-info-value-letter-spacing;
    line-height: $df-info-value-line-height;
    color: $df-info-value-font-color;
  }

  .vertical-middle { /*垂直居中*/
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}

.red-inspector {
  color: red;
  position: relative;
  left: -4px;
  font-size: calc(#{$df-info-label-font-size} * 0.9);
}
</style>
